const _temp0 = require("../intl/en-US.json");
module.exports = {
  "en-US": _temp0
}